import styled from "styled-components";

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 100%;
  padding: 30px;
  ${(props) =>
    props.background &&
    `background-image: url(${props.background});
        background-size: cover;
        `}

  .wrapper {
    text-align: center;
    cursor: pointer;
    .title,
    .subtitle {
      color: white;
    }
  }

  .close {
    cursor: pointer;
    color: white;
    position: relative;
    margin: 0 0 auto auto;
  }
`;
